import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { BaseGas } from "./baseGas";

export class Gas extends BaseGas {
	static key = "Gas";

	protected gasClass(): new (xy: XY, compression?: number) => BaseGas {
		return Gas;
	}

	static deserialize(data: any): Gas {
		const g = new Gas(deserializeXY(data.xy), data.compression);
		g.visualId = data.visualId;
		return g;
	}
}
